// FILE: src/components/ui/Loader.js
import React from 'react';
import { Loader2 } from 'lucide-react';
import { APP_LOGO_SRC } from '../../constants/branding';

export const FullScreenLoader = () => (
    <div className="app-splash" role="status" aria-live="polite" aria-label="Loading Trader Journal">
        <div className="app-splash__glow" aria-hidden="true" />
        <div className="app-splash__mark">
            <span className="app-splash__orbit app-splash__orbit--outer" aria-hidden="true" />
            <span className="app-splash__orbit app-splash__orbit--inner" aria-hidden="true" />
            <img className="app-splash__logo" src={APP_LOGO_SRC} alt="" />
        </div>
        <div className="app-splash__copy">
            <span className="app-splash__eyebrow">TRADER JOURNAL</span>
            <span className="app-splash__message">Preparing your workspace</span>
        </div>
        <span className="app-splash__progress" aria-hidden="true"><span /></span>
    </div>
);

export const InlineLoader = () => (
    <div className="flex items-center justify-center h-64">
        <Loader2 className="animate-spin text-[var(--color-accent-primary)]" size={32} />
    </div>
);
